import {useEffect, useState} from 'react'
import {KTIcon} from '../../../../../_metronic/helpers'
import useMenuList from '../../../../hooks/useMenuList'
import useSubmenuList from '../../../../hooks/useSubmenuList'
import {BASE_URL} from '../../../config'
import toast from 'react-hot-toast'
import axios from 'axios'
import {
  IAssignPermissionValuesType,
  IMenusAndSubmenus,
  IRoleDetailsAPIRes,
  ISendPermission,
  ISubMenu,
  Role,
} from '../../user-role/_model'
import {IMenu} from '../../../menu-management/menu/_modal'
import {ISubmenu} from '../../../menu-management/sub-menu/_model'
import useLinkList from '../../../../hooks/useLinkLIst'
import {ILink} from '../../../menu-management/link/_modal'
import useUserRole from '../../../../hooks/useUserRole'
import {useFormik} from 'formik'
import ReactSelectBox from '../../../../utils/components/ReactSelectBox'
import {useMutation} from 'react-query'
import {
  GET_ROLE_DETAILS_URL,
  useUserStateProvider,
} from '../../../../utils/contextProvider/UserStateProvider'
import {ISelectOption} from '../../../../utils/core/_model'
import {useAuth} from '../../../auth'

const UPDATE_ROLE_DETAILS_BY_ID = `${BASE_URL}/api/protect/updateRoleDetails`

type Props = {
  selectedRole: Role | null
  roles: ISelectOption[]
}

const AssignPermissionForm = ({selectedRole, roles}: Props) => {
  const {options: menus} = useMenuList()
  const {options: submenus} = useSubmenuList()
  const {options: links} = useLinkList()
  const {roleDetailMenus} = useUserStateProvider()
  const {currentUser} = useAuth()

  const [menusAndSubmenus, setMenusAndSubmenus] = useState<IMenusAndSubmenus[]>([])
  // TEMPORARY //
  const [filterMenusAndSubmenus, setFilterMenusAndSubmenus] = useState<IMenusAndSubmenus[]>([])

  const {mutateAsync: updateRoleDetail} = useMutation({
    mutationFn: async (sendvalues: ISendPermission) => {
      if (!formik.values.roleId) {
        toast.error('Select a role')
        return
      }
      toast.loading('Processing..')
      const response = await axios.post(UPDATE_ROLE_DETAILS_BY_ID, sendvalues)
    },
    onSuccess: () => {
      toast.dismiss()
      toast.success('Updated')
    },
  })

  const formik = useFormik<IAssignPermissionValuesType>({
    initialValues: {roleId: null, roleName: '', permissions: []},
    onSubmit: async (values) => {
      try {
        // console.log(values)
      } catch (error) {
        console.log(error)
      }
    },
  })

  const resetForm = () => {
    formik.resetForm()
  }

  function transformRoleDetailsArray(apiRes: IRoleDetailsAPIRes[]): IMenusAndSubmenus[] {
    return apiRes.map((item) => {
      const transformedSubmenus: ISubMenu[] | undefined =
        item.submenus && item.submenus.length > 0
          ? item.submenus.map((sub) => ({
              ...sub,
              submenu_link: '',
              view_level: sub.view_level,
            }))
          : undefined

      return {
        ...item.menus,
        menu_link: '', // keep blank for now
        view_level: item.menus.view_level,
        ...(transformedSubmenus ? {submenus: transformedSubmenus} : {}),
      }
    })
  }

  function combineMenuWithSubmenu(
    menus: IMenu[],
    submenus: ISubmenu[],
    links: ILink[]
  ): IMenusAndSubmenus[] {
    return menus.map((menu) => {
      // find menu link
      const menuLinkObj = links.find((link) => link.link_id === menu.link_id)
      const menu_link = menuLinkObj ? menuLinkObj.link_value : ''

      // filter submenus for this menu
      const subMenuWithLinks: ISubMenu[] = submenus
        .filter((sub) => sub.id_menu === menu.id_menu)
        .map((sub) => {
          const subLinkObj = links.find((link) => link.link_id === sub.link_id)
          return {
            ...sub,
            submenu_link: subLinkObj ? subLinkObj.link_value : '',
            view_level: 'N',
          }
        })

      return {
        ...menu,
        menu_link,
        submenus: subMenuWithLinks.length > 0 ? subMenuWithLinks : [],
        view_level: 'Y',
      }
    })
  }

  const onSelectRole = (id: number) => formik.setFieldValue('roleId', id)

  useEffect(() => {
    if (menus.length > 0 && submenus.length > 0) {
      const combined = combineMenuWithSubmenu(menus, submenus, links)

      // I WASTE 3 FUCKING HOURS FOR THIS SIMPLE FUNCTION WHICH IS UNACCEPTBLE TOTALLY UNACCEPTABLE
      const menusWithViewableSubmenus = combined
        .map((combineMenu): IMenusAndSubmenus | null => {
          // Find corresponding role menu
          const roleMenu = roleDetailMenus.find((rm) => rm.id_menu === combineMenu.id_menu)

          // Return null if no corresponding role menu found
          if (!roleMenu) return null

          // Get viewable submenu IDs from role (if submenus exist)
          const viewableSubmenuIds = roleMenu.submenus
            ? new Set(
                roleMenu.submenus
                  .filter((submenu) => submenu.view_level === 'Y')
                  .map((submenu) => submenu.id_submenu)
              )
            : new Set()

          // Filter actual submenus based on role permissions
          const viewableSubmenus = combineMenu.submenus?.filter((submenu) =>
            viewableSubmenuIds.has(submenu.id_submenu)
          )

          // Return menu with filtered submenus (keeping original structure)
          return {
            ...combineMenu,
            submenus: viewableSubmenus, // This maintains the optional nature
          }
        })
        .filter((menu): menu is IMenusAndSubmenus => menu !== null)

      const roleWiseViewable = currentUser?.author_id === 0 ? combined : menusWithViewableSubmenus

      setMenusAndSubmenus(roleWiseViewable)
      // setMenusAndSubmenus(combined)

      const initialValues: IAssignPermissionValuesType = {
        roleId: null,
        roleName: '',
        permissions: combined.flatMap((menu) => [
          {
            id: menu.id_menu,
            isMenu: 1 as 1,
            accessStatus: 'N' as 'N', // default
          },
          ...(menu.submenus?.map((sub) => ({
            id: sub.id_submenu,
            isMenu: 0 as 0,
            accessStatus: 'N' as 'N',
            menuId: menu.id_menu,
          })) || []),
        ]),
      }

      formik.setValues(initialValues)
    }
  }, [submenus, menus, selectedRole])

  useEffect(() => {
    const getRoleDetails = async (id: number) => {
      try {
        toast.loading('Processing..')
        const response = await axios.get<IRoleDetailsAPIRes[]>(`${GET_ROLE_DETAILS_URL}${id}`)
        // console.log(response.data)
        const transformed = transformRoleDetailsArray(response.data)
        // console.log(transformed)
        setMenusAndSubmenus(transformed)

        const initialValues: IAssignPermissionValuesType = {
          roleId: selectedRole?.id_level!,
          roleName: selectedRole?.level_name!,
          permissions: transformed.flatMap((menu) => [
            {
              id: menu.id_menu,
              isMenu: 1 as 1,
              accessStatus: menu.view_level,
            },
            ...(menu.submenus?.map((sub) => ({
              id: sub.id_submenu,
              isMenu: 0 as 0,
              accessStatus: sub.view_level,
              menuId: menu.id_menu,
            })) || []),
          ]),
        }

        // console.log(initialValues)

        formik.setValues(initialValues)
        toast.dismiss()
      } catch (error) {
        console.log(error)
      }
    }

    resetForm()
    if (selectedRole) {
      getRoleDetails(selectedRole.id_level)
    } else {
      const combined = combineMenuWithSubmenu(menus, submenus, links)
      setMenusAndSubmenus(combined)

      const initialValues: IAssignPermissionValuesType = {
        roleId: null,
        roleName: '',
        permissions: combined.flatMap((menu) => [
          {
            id: menu.id_menu,
            isMenu: 1 as 1,
            accessStatus: 'N' as 'N', // default
          },
          ...(menu.submenus?.map((sub) => ({
            id: sub.id_submenu,
            isMenu: 0 as 0,
            accessStatus: 'N' as 'N',
            menuId: menu.id_menu,
          })) || []),
        ]),
      }

      formik.setValues(initialValues)
    }
  }, [selectedRole])

  // TEMPORARY //
  useEffect(() => {
    if (menusAndSubmenus && menusAndSubmenus.length > 0) {
      const cloned = menusAndSubmenus

      const filtered = cloned.filter((menu) =>
        currentUser?.user_profile !== 2 ? menu.menu_name !== 'Users' : menu
      )

      setFilterMenusAndSubmenus(filtered)
    }
  }, [menusAndSubmenus])

  return (
    <div className='modal fade' tabIndex={-1} id='kt_modal_1'>
      {/* begin::Modal dialog */}
      <div className='modal-dialog modal-dialog-centered modal-xl'>
        {/* begin::Modal content */}
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title fs-2'>Assign Permission Form</h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
            >
              <KTIcon iconName='cross' className='fs-1' />
            </div>
          </div>
          {/* begin::Modal body */}
          <div className='modal-body scroll-y my-5 mx-10'>
            <form onSubmit={formik.handleSubmit}>
              <div className='col'>
                <div className='fv-row mb-7'>
                  <label className='required fw-semibold fs-6 mb-2'>Role</label>

                  <ReactSelectBox
                    placeholder='Select role'
                    options={roles}
                    formik={formik}
                    fieldValue='roleName'
                    setSelect={onSelectRole}
                    disable={selectedRole ? true : false}
                  />
                </div>
              </div>

              <label className='required fw-semibold fs-3 mb-2'>Menu/Submenu Assign</label>
              {filterMenusAndSubmenus.map((menu) => (
                <div key={menu.id_menu}>
                  {/* Menu Checkbox */}
                  <label className='form-check form-check-sm form-check-custom form-check-solid me-5 me-lg-20 mb-6'>
                    <input
                      type='checkbox'
                      className='form-check-input custom-input'
                      checked={
                        formik.values.permissions.find(
                          (p) => p.id === menu.id_menu && p.isMenu === 1
                        )?.accessStatus === 'Y'
                      }
                      onChange={async (e) => {
                        if (!formik.values.roleId) {
                          toast.error('Select a role')
                          return
                        }

                        const checked = e.target.checked ? 'Y' : 'N'

                        // Update menu and all its submenus
                        const newPerms = formik.values.permissions.map((perm) => {
                          if (perm.isMenu === 1 && perm.id === menu.id_menu) {
                            console.log(perm)
                            return {...perm, accessStatus: checked}
                          }
                          if (perm.isMenu === 0 && perm.menuId === menu.id_menu) {
                            console.log(perm)
                            return {...perm, accessStatus: checked}
                          }
                          return perm
                        })

                        console.log(newPerms)

                        formik.setFieldValue('permissions', newPerms)

                        // Call API for menu only once
                        const sendvalues: ISendPermission = {
                          id: menu.id_menu,
                          isMenu: 1,
                          roleId: formik.values.roleId!,
                          accessStatus: checked,
                          addStatus: 'Y',
                          editStatus: 'Y',
                        }
                        await updateRoleDetail(sendvalues)
                      }}
                    />
                    <span className='fs-4 fw-bold ms-3'>{menu.menu_name}</span>
                  </label>

                  {/* Submenus */}
                  {menu.submenus?.map((sub) => (
                    <div key={sub.id_submenu} style={{paddingLeft: '20px'}}>
                      <label className='form-check form-check-sm form-check-custom form-check-solid me-5 me-lg-20 mb-3'>
                        <input
                          type='checkbox'
                          className='form-check-input custom-input'
                          checked={
                            formik.values.permissions.find(
                              (p) => p.id === sub.id_submenu && p.isMenu === 0
                            )?.accessStatus === 'Y'
                          }
                          onChange={async (e) => {
                            if (!formik.values.roleId) {
                              toast.error('Select a role')
                              return
                            }

                            const checked = e.target.checked ? 'Y' : 'N'

                            // Update this submenu
                            let newPerms = formik.values.permissions.map((perm) =>
                              perm.isMenu === 0 && perm.id === sub.id_submenu
                                ? {...perm, accessStatus: checked}
                                : perm
                            )

                            // Check all submenus under this menu
                            const updatedSubmenuPerms = newPerms.filter(
                              (p) => p.menuId === menu.id_menu && p.isMenu === 0
                            )
                            const allSubChecked = updatedSubmenuPerms.every(
                              (s) => s.accessStatus === 'Y'
                            )
                            const allSubUnchecked = updatedSubmenuPerms.every(
                              (s) => s.accessStatus === 'N'
                            )

                            // Sync parent menu if all checked or all unchecked
                            newPerms = newPerms.map((perm) =>
                              perm.isMenu === 1 && perm.id === menu.id_menu
                                ? {
                                    ...perm,
                                    accessStatus: allSubChecked
                                      ? 'Y'
                                      : allSubUnchecked
                                      ? 'N'
                                      : perm.accessStatus, // keep as-is if mixed
                                  }
                                : perm
                            )

                            formik.setFieldValue('permissions', newPerms)

                            // Call API for submenu
                            const submenuPayload: ISendPermission = {
                              id: sub.id_submenu,
                              isMenu: 0,
                              roleId: formik.values.roleId!,
                              accessStatus: checked,
                              addStatus: 'Y',
                              editStatus: 'Y',
                            }
                            await updateRoleDetail(submenuPayload)

                            // Call API for parent menu only if all submenus match
                            if (allSubChecked || allSubUnchecked) {
                              const parentPayload: ISendPermission = {
                                id: menu.id_menu,
                                isMenu: 1,
                                roleId: formik.values.roleId!,
                                accessStatus: allSubChecked ? 'Y' : 'N',
                                addStatus: 'Y',
                                editStatus: 'Y',
                              }
                              await updateRoleDetail(parentPayload)
                            }
                          }}
                        />
                        <span className='fs-4 fw-bold ms-3'>{sub.submenu_name}</span>
                      </label>
                    </div>
                  ))}
                </div>
              ))}

              <div className='text-center pt-15'>
                {/* <button
                  type='reset'
                  className='btn btn-light me-3 border border-gray-600'
                  data-kt-users-modal-action='cancel'
                  data-bs-dismiss='modal'
                  aria-label='Close'
                  onClick={resetForm}
                >
                  CLOSE
                </button>

                <button
                  type='submit'
                  className='btn btn-primary me-3'
                  data-kt-users-modal-action='cancel'
                  data-bs-dismiss='modal'
                  aria-label='Close'
                >
                  SUBMIT
                </button> */}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AssignPermissionForm
